import { Injectable } from '@angular/core';
import { AppMenu } from '../models/app-menu';
import { MonitoringAlarmSection, ProjectConfiguration } from "../../features/project/models/project-configuration";

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private _monitoringAlarmSections: MonitoringAlarmSection[];

  constructor(
  ) { }

  addAlarmsMenu = (projectId: number, allAppMenu: AppMenu[], configurations: ProjectConfiguration[], lang: string, selectedProjectIds?: string):   AppMenu[] => {
    let monitoringAlarmSections = configurations ? configurations
          .filter(configuration => String(projectId) === String(0) ? true : String(configuration.projectId) === String(projectId))
          .filter(configuration => String(projectId) === String(0) ? (selectedProjectIds ? !!selectedProjectIds.split('-').find(projectId => projectId === String(configuration.projectId)) : false) : true)
          .reduce((acc: MonitoringAlarmSection[], configuration) => {
          return configuration.monitoringAlarmSections ? [
            ...acc,
            ...configuration.monitoringAlarmSections.map(section => ({
              ...section,
              projectId: configuration.projectId
            }))
          ]: acc
    }, []) : [];

    this._monitoringAlarmSections = Object.values(
      monitoringAlarmSections.reduce((acc, obj) => ({ ...acc, [obj.url]: obj }), {})
    );

    const monitoringMenuIdx = allAppMenu.findIndex(menu => menu.name === "I18N_NAV.MONITORING")
  
    allAppMenu[monitoringMenuIdx].items = allAppMenu[monitoringMenuIdx].items?.reduce((acc: AppMenu[], item) => {
         if (item.name === "I18N_NAV.MONITORING_CAPS") {
            item.items = [
              ...item.items?.filter(menu => menu.page !== "monitoring-sections") || [],
              ...this._monitoringAlarmSections.map(section => ({
                "name": section.name?.find(name => name.language === lang)?.text || "I18N_NAV.MISSING_SECTION_NAME",
                "visible": true,
                "page": "monitoring-sections",
                "params": {
                  "alarmType": section.url ? encodeURIComponent(section.url) : "INVALID_URL"
                }
              }))
            ].map(item => item.params && item.params.alarmType === "INVALID_URL" ? ({
              ...item,
              disabled:true,
              disabledReason: "I18N_NAV.INVALID_URL"
            }): item)
         }
      return [
        ...acc,
        item
      ];
    }, [])
    
    return allAppMenu;
  }

  getMonitoringAlarmSectionByUrl(url: string) {
    return this._monitoringAlarmSections?.find(section => section.url === url);
  }
}
